import { configureStore } from "@reduxjs/toolkit";
import LayoutReducers from "./Reducers/Layout/LayoutReducers";
import ThemeCustomizerReducers from "./Reducers/Layout/ThemeCustomizerReducers";
import LetterBoxSlice from "./Reducers/LetterBoxSlice";
import ProjectSlice from "./Reducers/ProjectSlice";
import BookmarkTabSlice from "./Reducers/BookmarkTabSlice";
import ChatSlice from "./Reducers/ChatSlice";
import ContactReducer from "./Reducers/ContactReducer";
import AddProductSlice from "./Reducers/ECommerce/AddProductSlice";
import CartSlice from "./Reducers/ECommerce/CartSlice";
import FilterSlice from "./Reducers/ECommerce/FilterSlice";
import ProductSlice from "./Reducers/ECommerce/ProductSlice";
import TaskSlice from "./Reducers/TaskSlice";
import ToDoSlice from "./Reducers/ToDoSlice";
import authReducer from "./Reducers/Layout/AuthReducer";

export const store = configureStore({
  reducer: {
    layout: LayoutReducers,
    themeCustomizer: ThemeCustomizerReducers,
    letterBox: LetterBoxSlice,
    project: ProjectSlice,
    chat:ChatSlice,
    filterData: FilterSlice,
    product: ProductSlice,
    contact: ContactReducer,
    cartData: CartSlice,
    todo:ToDoSlice,
    bookmarkTab:BookmarkTabSlice,
    task: TaskSlice,
    addProduct: AddProductSlice,
    auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
